export default {
  "content": "<path fill=\"#028EB7\" d=\"M12.727 14.774c-.615.616-1.382.892-2.698.893H3.594c-1.316 0-2.083-.277-2.698-.893-.616-.615-.892-1.383-.892-2.7v-6.43c0-1.318.276-2.085.892-2.7.615-.616 1.382-.893 2.7-.893l5.259-.001a.68.68 0 01.68.68 3.404 3.404 0 003.405 3.405.68.68 0 01.68.68v5.259c0 1.317-.277 2.085-.893 2.7zm.213-9.32a2.723 2.723 0 110-5.447 2.723 2.723 0 010 5.447z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};